var render, staticRenderFns
import script from "./AdmisionformPostulacion.vue?vue&type=script&lang=js"
export * from "./AdmisionformPostulacion.vue?vue&type=script&lang=js"
import style0 from "./AdmisionformPostulacion.vue?vue&type=style&index=0&id=06b2f8a2&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06b2f8a2",
  null
  
)

export default component.exports